export default __webpack_public_path__ + "static/media/hero4.55dbff01.svg";